const VERSION = "8.4.1";
export {
  VERSION
};
